var colorCode = {
    "CGX-GY-10L": "#8c8c8c",
    "CGX-GY-20L": "#999999",
    "CGX-GY-30L": "#a6a6a6",
    "CGX-GY-40L": "#b3b3b3",
    "CGX-GY-50L": "#bfbfbf",
    "CGX-GY-60L": "#cccccc",
    "CGX-GY-70L": "#d9d9d9",
    "CGX-GY-80L": "#e6e6e6",
    "CGX-GY-90L": "#f2f2f2",
    "CGX-GY-100L": "#ffffff",
    "CGX-GY-00N": "#7F7F7F",
    "CGX-GY-10D": "#737373",
    "CGX-GY-20D": "#666666",
    "CGX-GY-30D": "#595959",
    "CGX-GY-40D": "#4d4d4d",
    "CGX-GY-50D": "#404040",
    "CGX-GY-60D": "#333333",
    "CGX-GY-70D": "#262626",
    "CGX-GY-80D": "#1a1a1a",
    "CGX-GY-90D": "#0d0d0d",
    "CGX-GY-100D": "#000000",
    "CGX-GR-10L": "#6da201",
    "CGX-GR-20L": "#80bf03",
    "CGX-GR-30L": "#97e105",
    "CGX-GR-40L": "#a9f80d",
    "CGX-GR-50L": "#b5f830",
    "CGX-GR-60L": "#bff750",
    "CGX-GR-70L": "#cbf872",
    "CGX-GR-80L": "#d6f891",
    "CGX-GR-90L": "#e2fab3",
    "CGX-GR-100L": "#edfbd0",
    "CGX-GR-00N": "#558000",
    "CGX-GR-10D": "#507704",
    "CGX-GR-20D": "#4c6e07",
    "CGX-GR-30D": "#4b6b0b",
    "CGX-GR-40D": "#46630d",
    "CGX-GR-50D": "#425b10",
    "CGX-GR-60D": "#3e5412",
    "CGX-GR-70D": "#3a4d14",
    "CGX-GR-80D": "#394a17",
    "CGX-GR-90D": "#354319",
    "CGX-GR-100D": "#313d1a",
    "CGX-PR-10L": "#7723af",
    "CGX-PR-20L": "#8826c9",
    "CGX-PR-30L": "#9833db",
    "CGX-PR-40L": "#a54ce1",
    "CGX-PR-50L": "#b365e7",
    "CGX-PR-60L": "#c07eec",
    "CGX-PR-70L": "#cd98f1",
    "CGX-PR-80L": "#dab2f5",
    "CGX-PR-90L": "#e7cdf9",
    "CGX-PR-100L": "#f4e8fc",
    "CGX-PR-00N": "#651f93",
    "CGX-PR-10D": "#5f1f89",
    "CGX-PR-20D": "#59207e",
    "CGX-PR-30D": "#531f75",
    "CGX-PR-40D": "#4c1f6b",
    "CGX-PR-50D": "#471e62",
    "CGX-PR-60D": "#411d58",
    "CGX-PR-70D": "#3b1c4f",
    "CGX-PR-80D": "#351b46",
    "CGX-PR-90D": "#2f193e",
    "CGX-PR-100D": "#291736",
    "CGX-MG-10L": "#e90156",
    "CGX-MG-20L": "#fd0861",
    "CGX-MG-30L": "#fc2775",
    "CGX-MG-40L": "#fb4185",
    "CGX-MG-50L": "#fb6099",
    "CGX-MG-60L": "#fb79a9",
    "CGX-MG-70L": "#fb98bc",
    "CGX-MG-80L": "#fcb1cc",
    "CGX-MG-90L": "#fdcedf",
    "CGX-MG-100L": "#fee7ef",
    "CGX-MG-00N": "#cc004b",
    "CGX-MG-10D": "#bb0749",
    "CGX-MG-20D": "#a60c45",
    "CGX-MG-30D": "#971242",
    "CGX-MG-40D": "#84153e",
    "CGX-MG-50D": "#76193b",
    "CGX-MG-60D": "#651b36",
    "CGX-MG-70D": "#591d33",
    "CGX-MG-80D": "#491d2d",
    "CGX-MG-90D": "#3f1d29",
    "CGX-MG-100D": "#321b23",
    "CGX-BL-10L": "#0194e9",
    "CGX-BL-20L": "#08a3fd",
    "CGX-BL-30L": "#27aefc",
    "CGX-BL-40L": "#41b7fb",
    "CGX-BL-50L": "#60c2fb",
    "CGX-BL-60L": "#79cbfb",
    "CGX-BL-70L": "#98d7fb",
    "CGX-BL-80L": "#b1e0fc",
    "CGX-BL-90L": "#ceecfd",
    "CGX-BL-100L": "#e7f5fe",
    "CGX-BL-00N": "#0081cc",
    "CGX-BL-10D": "#047abe",
    "CGX-BL-20D": "#076fab",
    "CGX-BL-30D": "#0a689e",
    "CGX-BL-40D": "#0c5e8d",
    "CGX-BL-50D": "#0e5781",
    "CGX-BL-60D": "#0f4d70",
    "CGX-BL-70D": "#104665",
    "CGX-BL-80D": "#103c56",
    "CGX-BL-90D": "#11364b",
    "CGX-BL-100D": "#0f2c3d",
    "CGX-DR-10L": "#c02f2a",
    "CGX-DR-20L": "#d6342e",
    "CGX-DR-30L": "#df4943",
    "CGX-DR-40L": "#e75a55",
    "CGX-DR-50L": "#ee716d",
    "CGX-DR-60L": "#f38582",
    "CGX-DR-70L": "#f89e9b",
    "CGX-DR-80L": "#fbb4b1",
    "CGX-DR-90L": "#fdcfce",
    "CGX-DR-100L": "#ffe7e6",
    "CGX-DR-00N": "#a32d29",
    "CGX-DR-10D": "#9a2c28",
    "CGX-DR-20D": "#8e2825",
    "CGX-DR-30D": "#852723",
    "CGX-DR-40D": "#7c2522",
    "CGX-DR-50D": "#742320",
    "CGX-DR-60D": "#67201d",
    "CGX-DR-70D": "#5f1e1c",
    "CGX-DR-80D": "#561c1a",
    "CGX-DR-90D": "#4b1816",
    "CGX-DR-100D": "#421614",
    "CGX-DO-10L": "#d45616",
    "CGX-DO-20L": "#e9601c",
    "CGX-DO-30L": "#ec7336",
    "CGX-DO-40L": "#ef834d",
    "CGX-DO-50L": "#f39668",
    "CGX-DO-60L": "#f5a67f",
    "CGX-DO-70L": "#f8ba9b",
    "CGX-DO-80L": "#facab2",
    "CGX-DO-90L": "#fcdecf",
    "CGX-DO-100L": "#feeee7",
    "CGX-DO-00N": "#b84b14",
    "CGX-DO-10D": "#ac4815",
    "CGX-DO-20D": "#9d4315",
    "CGX-DO-30D": "#923f16",
    "CGX-DO-40D": "#843a15",
    "CGX-DO-50D": "#793715",
    "CGX-DO-60D": "#6b3114",
    "CGX-DO-70D": "#612e14",
    "CGX-DO-80D": "#542812",
    "CGX-DO-90D": "#4a2411",
    "CGX-DO-100D": "#3d1f0f",
    "CGX-DY-10L": "#daa810",
    "CGX-DY-20L": "#eeb817",
    "CGX-DY-30L": "#f1c132",
    "CGX-DY-40L": "#f2c84a",
    "CGX-DY-50L": "#f5d166",
    "CGX-DY-60L": "#f7d87e",
    "CGX-DY-70L": "#f9e19a",
    "CGX-DY-80L": "#fbe8b2",
    "CGX-DY-90L": "#fcf1cf",
    "CGX-DY-100L": "#fef8e7",
    "CGX-DY-00N": "#bd910f",
    "CGX-DY-10D": "#b18910",
    "CGX-DY-20D": "#a17d12",
    "CGX-DY-30D": "#967513",
    "CGX-DY-40D": "#866913",
    "CGX-DY-50D": "#7c6113",
    "CGX-DY-60D": "#6c5613",
    "CGX-DY-70D": "#634f13",
    "CGX-DY-80D": "#544412",
    "CGX-DY-90D": "#4b3c11",
    "CGX-DY-100D": "#3d320f",
    "CGX-LG-10L": "#01d0d0",
    "CGX-LG-20L": "#02eded",
    "CGX-LG-30L": "#13fbfb",
    "CGX-LG-40L": "#32fbfb",
    "CGX-LG-50L": "#51fbfb",
    "CGX-LG-60L": "#70fbfb",
    "CGX-LG-70L": "#8efbfb",
    "CGX-LG-80L": "#acfcfc",
    "CGX-LG-90L": "#c9fcfc",
    "CGX-LG-100L": "#e7fefe",
    "CGX-LG-00N": "#00b2b3",
    "CGX-LG-10D": "#03a5a5",
    "CGX-LG-20D": "#069898",
    "CGX-LG-30D": "#098b8b",
    "CGX-LG-40D": "#0b7f7f",
    "CGX-LG-50D": "#0d7373",
    "CGX-LG-60D": "#0e6767",
    "CGX-LG-70D": "#0f5c5c",
    "CGX-LG-80D": "#105151",
    "CGX-LG-90D": "#104747",
    "CGX-LG-100D": "#0f3d3d",
    "CGX-RD-10L": "#e83730",
    "CGX-RD-20L": "#ea4843",
    "CGX-RD-30L": "#ed5f5a",
    "CGX-RD-40L": "#ef706c",
    "CGX-RD-50L": "#f18783",
    "CGX-RD-60L": "#f39995",
    "CGX-RD-70L": "#f6afac",
    "CGX-RD-80L": "#f8c1bf",
    "CGX-RD-90L": "#fad7d6",
    "CGX-RD-100L": "#fce9e8",
    "CGX-RD-00N": "#e62019",
    "CGX-RD-10D": "#d3231d",
    "CGX-RD-20D": "#bd241f",
    "CGX-RD-30D": "#ab2521",
    "CGX-RD-40D": "#972521",
    "CGX-RD-50D": "#872522",
    "CGX-RD-60D": "#732321",
    "CGX-RD-70D": "#652220",
    "CGX-RD-80D": "#531f1d",
    "CGX-RD-90D": "#461d1b",
    "CGX-RD-100D": "#361817",
    "CGX-OR-10L": "#fd671c",
    "CGX-OR-20L": "#fb7532",
    "CGX-OR-30L": "#f9864d",
    "CGX-OR-40L": "#f89462",
    "CGX-OR-50L": "#f8a57c",
    "CGX-OR-60L": "#f8b391",
    "CGX-OR-70L": "#f9c4aa",
    "CGX-OR-80L": "#f9d1bd",
    "CGX-OR-90L": "#fbe2d5",
    "CGX-OR-100L": "#fcefe8",
    "CGX-OR-00N": "#ff5500",
    "CGX-OR-10D": "#e95207",
    "CGX-OR-20D": "#ce4d0d",
    "CGX-OR-30D": "#ba4a12",
    "CGX-OR-40D": "#a24516",
    "CGX-OR-50D": "#8f4119",
    "CGX-OR-60D": "#793a1b",
    "CGX-OR-70D": "#69351c",
    "CGX-OR-80D": "#552e1b",
    "CGX-OR-90D": "#47291a",
    "CGX-OR-100D": "#362117",
    "CGX-AM-10L": "#fdc41c",
    "CGX-AM-20L": "#fbc932",
    "CGX-AM-30L": "#f9ce4d",
    "CGX-AM-40L": "#f8d362",
    "CGX-AM-50L": "#f8d97c",
    "CGX-AM-60L": "#f8de91",
    "CGX-AM-70L": "#f9e5aa",
    "CGX-AM-80L": "#f9eabd",
    "CGX-AM-90L": "#fbf1d5",
    "CGX-AM-100L": "#fcf7e8",
    "CGX-AM-00N": "#ffbf00",
    "CGX-AM-10D": "#e9b007",
    "CGX-AM-20D": "#ce9e0d",
    "CGX-AM-30D": "#ba9012",
    "CGX-AM-40D": "#a27f16",
    "CGX-AM-50D": "#8f7219",
    "CGX-AM-60D": "#79621b",
    "CGX-AM-70D": "#69561c",
    "CGX-AM-80D": "#55471b",
    "CGX-AM-90D": "#473c1a",
    "CGX-AM-100D": "#362e17",
    "CGX-GN-10L": "#95d416",
    "CGX-GN-20L": "#a4e91c",
    "CGX-GN-30L": "#b0ec36",
    "CGX-GN-40L": "#b9ef4d",
    "CGX-GN-50L": "#c5f368",
    "CGX-GN-60L": "#cef57f",
    "CGX-GN-70L": "#d9f89b",
    "CGX-GN-80L": "#e2fab2",
    "CGX-GN-90L": "#edfccf",
    "CGX-GN-100L": "#f6fee7",
    "CGX-GN-00N": "#81b814",
    "CGX-GN-10D": "#7aac16",
    "CGX-GN-20D": "#6f9b17",
    "CGX-GN-30D": "#689018",
    "CGX-GN-40D": "#5e8118",
    "CGX-GN-50D": "#577619",
    "CGX-GN-60D": "#4d6718",
    "CGX-GN-70D": "#465d18",
    "CGX-GN-80D": "#3d5016",
    "CGX-GN-90D": "#364616",
    "CGX-GN-100D": "#2d3913"
};

var graphColor = colorCode;